/**
 * Frontend configuration
 * 
 * API_URL: Base URL for backend API calls
 * - Uses REACT_APP_API_URL environment variable if set
 * - Falls back to localhost:5001 for development (port 5001 to avoid macOS AirPlay conflict)
 * 
 * GOOGLE_CLIENT_ID: Google OAuth client ID for authentication
 * 
 * Usage:
 *   import { API_URL } from '../config';
 *   const response = await axios.get(`${API_URL}/api/health`);
 * 
 * Note: JWT token handling is done in AuthContext.js
 */

export const API_URL = process.env.REACT_APP_API_URL !== undefined ? process.env.REACT_APP_API_URL : 'http://127.0.0.1:5001';
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

// Convenience function for building API endpoints
export const apiEndpoint = (path) => {
  // Ensure path starts with /
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_URL}${normalizedPath}`;
};

export default {
  API_URL,
  GOOGLE_CLIENT_ID,
  apiEndpoint,
};

